import moment from 'moment';
import { ObservationSummary } from '../../objects/observationSummary';

export class MockObservationMaker {
  public static doSummaryReplacements(id?: number): object {
    return MockObservationMaker.doReplacements(OBSERVATION_SUMMARY_TEMPLATE, id);
  }
  public static doDetailsReplacements(id?: number): object {
    return MockObservationMaker.doReplacements(OBSERVATION_DETAILS_TEMPLATE, id);
  }

  public static doReplacements(template: string, id?: number): object {
    id = null == id ? Math.floor(Math.random() * 100) : id;
    const randomNum1 = Math.floor(Math.random() * 20); // 0 to 19
    const randomNum2 = Math.floor(Math.random() * 20); // 0 to 19
    const randomNum3 = Math.floor(Math.random() * 10) % 3; // 0 to 2
    const randomLocation = JSON.stringify([
      15 - randomNum1 - Number(Math.random().toFixed(3)),
      60 - randomNum2 - Number(Math.random().toFixed(3)),
    ]);

    template = template.replace(/<<id>>/g, `${id}`);
    template = template.replace(/<<random-id-1>>/g, `${randomNum1}`);
    template = template.replace(/<<random-id-2>>/g, `${randomNum2}`);
    template = template.replace(/<<random-id-3>>/g, `${randomNum3}`);
    template = template.replace(/<<location>>/g, `${randomLocation}`);
    template = template.replace(
      /<<date>>/g,
      moment()
        .subtract(Math.floor(Math.random() * 10000), 'd')
        .toISOString(),
    );
    // try {
    //   JSON.parse(template);
    // } catch(err) {
    //   console.debug(template);
    // }
    return JSON.parse(template);
  }
}

const OBSERVATION_SUMMARY_TEMPLATE = `{
"${ObservationSummary.KEYS.ID}": "<<id>>"
,"${ObservationSummary.KEYS.OBS_TYPE_CODE}": "<<random-id-3>>"
,"${ObservationSummary.KEYS.DESCRIPTION}": "Desc <<id>>"
,"${ObservationSummary.KEYS.COUNTRY_CODE}": "<<random-id-1>>"
,"${ObservationSummary.KEYS.SOURCE_CODE}": "<<random-id-2>>"
,"${ObservationSummary.KEYS.DATE_OBSERVED}": "<<date>>"
,"${ObservationSummary.KEYS.LOCATION}": {
  "type": "Feature",
  "geometry": {
    "type": "Point",
    "coordinates": <<location>>
  }
}
}`;
// extends OBSERVATION_SUMMARY_TEMPLATE
const OBSERVATION_DETAILS_TEMPLATE = OBSERVATION_SUMMARY_TEMPLATE.replace(
  /}$/,
  `
,"keywords": [
  {"keyword_code": "<<random-id-1>>"},
  {"keyword_code": "<<random-id-2>>"}
]
,"properties": [
  {
    "property_code": "<<random-id-1>>",
    "property_value": "PROPERTY VALUE 1"
  },
  {
    "property_code": "<<random-id-2>>",
    "property_value": "PROPERTY VALUE 2"
  }
]
}`,
);
